import { BlankState } from '@domain-group/suit-theme'

import BlankStateImageUrl from '../../assets/no-templates.svg'

const NoFiltersBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImageUrl}>
    <BlankState.Title>
      No Filters Selected
    </BlankState.Title>

    <BlankState.Paragraph>
      Please select at least one filter to load templates.
    </BlankState.Paragraph>
  </BlankState>
)

export default NoFiltersBlankState
